let ProjectedOwnershipForce = {
    PROJECTED_OWNERSHIP_FORCE_SET_IS_ENABLED: 'PROJECTED_OWNERSHIP_FORCE_SET_IS_ENABLED',
    PROJECTED_OWNERSHIP_FORCE_SET_RANGE: 'PROJECTED_OWNERSHIP_FORCE_SET_RANGE',
    PROJECTED_OWNERSHIP_FORCE_SET_IGNORED_POSITION: 'PROJECTED_OWNERSHIP_FORCE_SET_IGNORED_POSITION',
    PROJECTED_OWNERSHIP_FORCE_SET_SUB_PERCENT: 'PROJECTED_OWNERSHIP_FORCE_SET_SUB_PERCENT',
    PROJECTED_OWNERSHIP_FORCE_SET_DATA_FROM_STORAGE: 'PROJECTED_OWNERSHIP_FORCE_SET_DATA_FROM_STORAGE',
};

export default ProjectedOwnershipForce;
